/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  generalsection: {
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000)
    }
  }
});
